import { ISubjectType } from 'APIPackage/DictionariesModule/interfaces/ISubjectType';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionarySubjectTypeSelectOption = makeCreateDictionarySelectOption<ISubjectType>('id', 'title');
